'use strict'

export const jsonData = () => ([
  {
    '_id': '17c71711e00003e026768b98',
    'title': 'Resumo do terceiro Meetup de Vue.js na Moip (São Paulo)',
    'tag': '',
    'short': 'Vue.js desponta cada vez mais como uma excelente [...]',
    'link': 'https://medium.com/@Juscilan/resumo-do-terceiro-meetup-de-vue-js-na-moip-s%C3%A3o-paulo-7f148eefd8c9#.nwxpppc8b',
    'date': '2017-03-17T02:00:00.000Z'
  },
  {
    '_id': '67c71711e00004e026768b98',
    'title': 'T.I para recrutadores — ioT (Internet das coisas)',
    'tag': '',
    'short': 'Conceitos fundamentais',
    'link': 'https://medium.com/@Juscilan/t-i-para-recrutadores-iot-internet-das-coisas-12a29f77942e#.w31vb3ew7',
    'date': '2017-02-10T02:00:00.000Z'
  },
  {
    '_id': '47c71711e00003e026768b98',
    'title': 'T.I para recrutadores — Git e Github',
    'tag': '',
    'short': 'Conceitos fundamentais',
    'link': 'https://medium.com/@Juscilan/t-i-para-recrutadores-git-e-github-fbf1375f9ce8#.sihuk6o5x',
    'date': '2017-02-08T02:00:00.000Z'
  },
  {
    '_id': '67c71711e02004e026768b98',
    'title': 'T.I para recrutadores — MVC',
    'tag': '',
    'short': 'Conceitos fundamentais',
    'link': 'https://medium.com/@Juscilan/t-i-para-recrutadores-mvc-56ec055f80b4#.vczw79stw',
    'date': '2017-02-06T02:00:00.000Z'
  },
  {
    '_id': '67c71711e03004e026767b98',
    'title': 'T.I para recrutadores — AngularJs',
    'tag': '',
    'short': 'Conceitos fundamentais',
    'link': 'https://medium.com/@Juscilan/t-i-para-recrutadores-angularjs-f6815f6a25dc#.z7grqwy5n',
    'date': '2017-02-03T02:00:00.000Z'
  },
  {
    '_id': '67c71711e03004e126768b98',
    'title': 'T.I para recrutadores — JavaScript',
    'tag': '',
    'short': 'Conceitos fundamentais',
    'link': 'https://medium.com/@Juscilan/t-i-para-recrutadores-javascript-68a5608ce178#.n3aevyer8',
    'date': '2017-02-01T02:00:00.000Z'
  },
  {
    '_id': '67c71711e03004e026768b98',
    'title': 'T.I para recrutadores — HTML e CSS',
    'tag': '',
    'short': 'Conceitos fundamentais',
    'link': 'https://medium.com/@Juscilan/t-i-para-recrutadores-html-e-css-30b69460f0f9#.zh1p90luj',
    'date': '2017-01-30T02:00:00.000Z'
  },
  {
    '_id': '67c70711e03004e036768b98',
    'title': 'T.I para recrutadores — NoSql',
    'tag': '',
    'short': 'Conceitos fundamentais ',
    'link': 'https://medium.com/@Juscilan/t-i-para-recrutadores-nosql-8888335059db#.ycdm8j7oq',
    'date': '2017-01-27T02:00:00.000Z'
  },
  {
    '_id': '67c70711e03004e026768b98',
    'title': 'T.I para recrutadores — Cloud',
    'tag': '',
    'short': 'Conceitos fundamentais ',
    'link': 'https://medium.com/@Juscilan/t-i-para-recrutadores-cloud-99064fce0125#.aes98mcw2',
    'date': '2017-01-25T02:00:00.000Z'
  },
  {
    '_id': '67c70711e03004e026768a98',
    'title': 'T.I para recrutadores — API e Webservices',
    'tag': '',
    'short': 'Conceitos fundamentais ',
    'link': 'https://medium.com/@Juscilan/ti-para-recrutadores-api-e-webservices-20ae02ce54ac#.4jjmnye0p',
    'date': '2017-01-23T02:00:00.000Z'
  },
  {
    '_id': '67c70711e03004e026768a41',
    'title': 'T.I para recrutadores — Node.js',
    'tag': '',
    'short': 'Conceitos fundamentais',
    'link': 'https://medium.com/@Juscilan/ti-para-recrutadores-node-js-dbbaae44c31c#.3jx19n9yn',
    'date': '2017-01-20T02:00:00.000Z'
  },
  {
    '_id': '57c70711e03004e026768a42',
    'title': 'Vuex a implementação da arquitetura flux de forma descomplicada',
    'tag': '',
    'short': 'Algumas ferramentas alcançam a eficiência pois foram desenvolvidas por quem domina o problema.  [mais...] ',
    'link': 'https://medium.com/@Juscilan/vuex-a-implementa%C3%A7%C3%A3o-da-arquitetura-flux-de-forma-descomplicada-98bcc979de2f#.98f7jvwkt',
    'date': '2016-09-20T02:00:00.000Z'
  },
  {
    '_id': '57c70711e03004e026768a36',
    'title': 'Vue.js muito além de uma biblioteca JavaScript',
    'tag': '',
    'short': 'As demandas para um desenvolvedor FrontEnd estão cada vez mais desafiadoras, interfaces cada vez mais interativas [mais...] ',
    'link': 'https://medium.com/@Juscilan/vue-js-muito-al%C3%A9m-de-uma-biblioteca-javascript-2cf3b315da8b#.yn9bzk37w',
    'date': '2016-09-16T02:00:00.000Z'
  },
  {
    '_id': '57c70711e03004e026768a35',
    'title': 'Como foi o primeiro Meetup de Vue.js em São Paulo',
    'tag': '',
    'short': 'Uma das libs JavaScript que vem chamando cada vez mais atenção da comun[mais...] ',
    'link': 'https://medium.com/@Juscilan/como-foi-o-primeiro-meetup-de-vue-js-em-s%C3%A3o-paulo-6b2ba50a7bdc#.ti5g63aqe',
    'date': '2016-09-09T02:00:00.000Z'
  },
  {
    '_id': '57c706d2e03004e026768a33',
    'title': 'NodeJS com Socket.io e Arduino',
    'tag': '',
    'short': 'Este artigo tem por objetivo abordar uma estratégia para acionar um Lme  [mais...]',
    'link': 'https://medium.com/@Juscilan/nodejs-com-socket-io-e-arduino-30f4922566f9#.64km3s17d',
    'date': '2016-03-23T03:00:00.000Z'
  }
])



// WEBPACK FOOTER //
// ./src/components/common/jm-data.js